<script setup lang="ts">
import type { PopoverContentEmits, PopoverContentProps, PopoverRootEmits, PopoverRootProps } from 'reka-ui'
import { PopoverAnchor, PopoverContent, PopoverRoot, PopoverTrigger, useForwardPropsEmits } from 'reka-ui'
import Tooltip from '~/components/ui/Tooltip.vue'

const props = defineProps<PopoverRootProps & PopoverContentProps & {
  tooltipContent?: string
}>()
const emits = defineEmits<PopoverRootEmits & PopoverContentEmits>()

const forward = useForwardPropsEmits(props, emits)
</script>

<template>
  <PopoverRoot v-bind="forward">
    <PopoverAnchor v-if="tooltipContent" as-child>
      <Tooltip :content="tooltipContent">
        <PopoverTrigger as-child>
          <slot name="trigger" />
        </PopoverTrigger>
      </Tooltip>
    </PopoverAnchor>
    <PopoverTrigger v-else as-child>
      <slot name="trigger" />
    </PopoverTrigger>
    <PopoverContent
      v-bind="forward"
      :side-offset="5"
      class="data-[state=open]:animate-fade-in-down data-[state=closed]:animate-fade-out-up z-50 flex flex-col rounded-xl bg-white text-black p-2 shadow-2xl outline-hidden"
    >
      <slot name="content" />
    </PopoverContent>
  </PopoverRoot>
</template>
